import React, { useRef, useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link, useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import dayjs from "dayjs";
import { useForm } from "react-hook-form";
import AuthServices from "../../../services/Auth";
import { ErrorToaster, SuccessToaster } from "../../components/toaster/Toaster";
import InputField from "../../components/Input";
import { passwordRegex } from "../../../utils";
import { Spinner } from "react-bootstrap";

const ResetPassword = () => {

  const route = all_routes;
  const { token } = useParams();
  const navigate = useNavigate();

  const { register, handleSubmit, formState: { errors }, watch } = useForm();
  const newPassword = useRef({});
  newPassword.current = watch("newPassword", "");

  const [loading, setLoading] = useState(false);

  // *For Password Visibility Toggle
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  // *For Reset Password
  const resetPassword = async (formData) => {
    setLoading(true)
    try {
      const obj = {
        new_password: formData.newPassword
      }
      const { message } = await AuthServices.resetPassword(token, obj)
      SuccessToaster(message)
      navigate(route.signin)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper login-new">
          <div className="container">
            <div className="login-content user-login">
              <div className="login-logo">
                <ImageWithBasePath src="assets/img/logo.png" alt="img" className="mb-2" />
              </div>
              <form style={{ width: '45%' }} onSubmit={handleSubmit(resetPassword)}>
                <div className="login-userset">
                  <div className="login-userheading">
                    <h3>Reset password?</h3>
                    <h4>
                      Enter New Password & Confirm Password to get inside.
                    </h4>
                  </div>
                  <div className="add-product mb-3">
                    <InputField
                      label="New Password"
                      type={isPasswordVisible ? "text" : "password"}
                      endAdornment={
                        <span
                          className={`fas toggle-password ${isPasswordVisible ? "fa-eye" : "fa-eye-slash"
                            }`}
                          onClick={() => setPasswordVisible((prevState) => !prevState)}
                        ></span>
                      }
                      error={errors?.newPassword?.message}
                      register={register("newPassword", {
                        required: 'Please enter the new password.',
                        pattern: {
                          value: passwordRegex,
                          message: 'Password contain minimum 8 characters, at least uppercase/lowercase letter, number and special character',
                        }
                      })}
                    />
                  </div>
                  <div className="add-product mb-3">
                    <InputField
                      label="Confirm Password"
                      type={isConfirmPasswordVisible ? "text" : "password"}
                      endAdornment={
                        <span
                          className={`fas toggle-password ${isConfirmPasswordVisible ? "fa-eye" : "fa-eye-slash"
                            }`}
                          onClick={() => setConfirmPasswordVisible((prevState) => !prevState)}
                        ></span>
                      }
                      error={errors?.confirmPassword?.message}
                      register={register("confirmPassword", {
                        required: 'Please enter the confirm password.',
                        validate: value => value === newPassword.current || "Confirm password does not match"
                      })}
                    />
                  </div>
                  <div className="form-login">
                    <button
                      className="btn btn-login"
                      type="submit"
                      disabled={loading}
                    >
                      {loading &&
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                      }
                      Reset Password
                    </button>
                  </div>
                  <div className="signinform text-center">
                    <h4>
                      Return to{" "}
                      <Link to={route.signin} className="hover-a">
                        {" "}
                        login{" "}
                      </Link>
                    </h4>
                  </div>
                </div>
              </form>
            </div>
            <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
              <p>Copyright © {dayjs().format('YYYY')} Slynx Technologies. All rights reserved</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
